export enum NotificationType {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Default = 'default',
}

export const ErrorMessage = {
    forbidden: `You don't have permissions to perform this action. Please, talk to your system administrator.`,
    default: 'Sorry, something went wrong. Please try again later.',
};
